<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_2"></a><a id="ch1fig1"></a><img alt="Image" src="images/f0002-01.jpg"/></p>
<p class="caption"><strong>1.1.</strong> Size comparison of the Pleistocene felid sabertooth <em>Smilodon populator</em> (background) and the Eocene creodont sabertooth <em>Machaeroides</em> eothen.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle02.vue?387bea8a